/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_End_Event_Punctuation_LabelInputs */



/**
* | output |
* | --- |
* | "End event on punctuation (. ? !)" |
*
* @param {Plain_Text_Import_End_Event_Punctuation_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_end_event_punctuation_label = /** @type {((inputs?: Plain_Text_Import_End_Event_Punctuation_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_End_Event_Punctuation_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer l'evenement sur ponctuation (. ? !)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis bei Satzzeichen beenden (. ? !)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termina l'evento con la punteggiatura (. ? !)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Завершение события по пунктуации (. ? !)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fin del evento en puntuación (. ? !)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("以标点符号（. ? !）结束事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("句読点（。? !）でイベントを終了します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विराम चिह्न (. ? !) पर समाप्ति घटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Finalizar evento na pontuação (. ? !)")
	return /** @type {LocalizedString} */ ("End event on punctuation (. ? !)")
});